/* eslint-disable jsx-a11y/label-has-for */

import React from 'react';
import PropTypes from 'prop-types';

import * as S from './styles';

const Radio = props => {
  const { values, selected, layout, onChange } = props;

  return (
    <S.Layout layout={layout}>
      {values.map(value => (
        <S.Label key={value.id} layout={layout}>
          <S.HiddenInput
            checked={selected === value.id}
            onChange={e => {
              onChange({
                id: value.id,
                checked: e.currentTarget.checked,
              });
            }}
            name={props.id}
            type="radio"
            value={String(value.id)}
          />
          <S.RadioButton checked={selected === value.id} />
          {value.text}
          {value.products !== undefined && (
            <S.Counter>({value.products})</S.Counter>
          )}
        </S.Label>
      ))}
    </S.Layout>
  );
};

const {
  string,
  number,
  arrayOf,
  shape,
  oneOfType,
  oneOf,
  bool,
  func,
} = PropTypes;

Radio.propTypes = {
  id: oneOfType([string, number]).isRequired,
  values: arrayOf(
    shape({
      id: oneOfType([string, number, bool]),
      text: string,
      products: number,
    })
  ).isRequired,
  selected: oneOfType([string, number, bool]),
  onChange: func,
  layout: oneOf(['vertical', 'horizontal']),
};

Radio.defaultProps = {
  selected: null,
  onChange: () => {},
  layout: 'vertical',
};

export default Radio;
